export default "__VITE_ASSET__mS$bCsbx__"